import { NoPaddedRow, Row } from "@inrange/theme-components";
import {
  DownloadFile,
  FileListTable,
  TableCellData,
} from "@inrange/theme-components/table";
import React from "react";

const SpvDocuments: React.FC = () => {
  const tableHead = <SpvDocumentsHeader />;
  const tableRows = <EmptyDocumentRow />;

  return (
    <>
      <Row $margin="8px" $padding="0"></Row>
      <NoPaddedRow>
        <FileListTable head={tableHead} rows={tableRows} />
      </NoPaddedRow>
    </>
  );
};

const SpvDocumentsHeader: React.FC = () => {
  return (
    <tr>
      <th>Name</th>
      <th>Relevant period</th>
      <th>Submitted date</th>
      <th></th>
    </tr>
  );
};

const EmptyDocumentRow = () => {
  return (
    <tr>
      <td colSpan={3} style={{ width: "70%" }}>
        <TableCellData>
          When your SPV has documents associated with it, you&apos;ll be able to
          access them here.
        </TableCellData>
      </td>
      <td align="right">
        <DownloadFile downloadDisabled={true} />
      </td>
    </tr>
  );
};

export default SpvDocuments;
